module.exports = __webpack_public_path__ + "img/Devil In The Shortwave.9c770355.jpg";